var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import File from './File';
const Svg = (_a) => {
    var { color = '#999' } = _a, props = __rest(_a, ["color"]);
    return (React.createElement(File, Object.assign({}, props),
        React.createElement("path", { fill: color, fillRule: "evenodd", d: "M16.4998 11.0549H7.49977c-.1656 0-.3-.1306-.3-.2916 0-.161.1344-.2917.3-.2917h9.00003c.1656 0 .3.1307.3.2917s-.1344.2916-.3.2916zM16.4998 12.8049H7.49977c-.1656 0-.3-.1306-.3-.2916 0-.161.1344-.2917.3-.2917h9.00003c.1656 0 .3.1307.3.2917s-.1344.2916-.3.2916zM16.4998 14.5549H7.49977c-.1656 0-.3-.1306-.3-.2916 0-.161.1344-.2917.3-.2917h9.00003c.1656 0 .3.1307.3.2917s-.1344.2916-.3.2916zM13.4998 16.3049H7.49977c-.1656 0-.3-.1306-.3-.2916 0-.161.1344-.2917.3-.2917h6.00003c.1656 0 .3.1307.3.2917s-.1344.2916-.3.2916zM13.4998 18.0549H7.49977c-.1656 0-.3-.1306-.3-.2916 0-.161.1344-.2917.3-.2917h6.00003c.1656 0 .3.1307.3.2917s-.1344.2916-.3.2916z", clipRule: "evenodd" })));
};
export default Svg;
//# sourceMappingURL=Default.js.map